"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeRouter = void 0;
var TypeRouter;
(function (TypeRouter) {
    /**
     * 새 웹뷰를 열어요
     * @required remote       리모트 웹 주소
     * @optional navbar       상단 바 표시 여부
     * @optional navbarTitle  상단 바 내 타이틀
     * @optional scrollable   스크롤 가능 여부
     * @optional enableSafeAreaInsets Safe Area까지 꽉 채울지 여부 (iOS Only)
     * @optional backSwipable 백스와이프 가능 여부
     * 또는
     * @optional app          로컬 웹뷰 주소 (없을 경우 자기 자신)
     * @required path         로컬 웹뷰 내 경로 (HashRouter)
     * @optional navbar       상단 바 표시 여부
     * @optional navbarTitle  상단 바 내 타이틀
     * @optional scrollable   스크롤 가능 여부
     * @optional enableSafeAreaInsets Safe Area까지 꽉 채울지 여부 (iOS Only)
     * @optional backSwipable 백스와이프 가능 여부 (iOS Only)
     */
    TypeRouter["ReqRouterPush"] = "REQ.ROUTER.PUSH";
    /**
     * 웹뷰를 닫아요
     */
    TypeRouter["ReqRouterPop"] = "REQ.ROUTER.POP";
    /**
     * 새 웹뷰를 Present로 열어요
     * (iOS에서만 특별하게 작동해요. Android에서는 REQ.ROUTER.PUSH와 동일하게 작동해요.)
     * @required remote       리모트 웹 주소
     * @optional navbar       상단 바 표시 여부
     * @optional navbarTitle  상단 바 내 타이틀
     * @optional scrollable   스크롤 가능 여부
     * @optional enableSafeAreaInsets Safe Area까지 꽉 채울지 여부 (iOS Only)
     * @optional backSwipable 백스와이프 가능 여부 (iOS Only)
     * 또는
     * @optional app          로컬 웹뷰 주소 (없을 경우 자기 자신)
     * @required path         로컬 웹뷰 내 경로 (HashRouter)
     * @optional navbar       상단 바 표시 여부
     * @optional navbarTitle  상단 바 내 타이틀
     * @optional scrollable   스크롤 가능 여부
     * @optional enableSafeAreaInsets Safe Area까지 꽉 채울지 여부 (iOS Only)
     * @optional backSwipable 백스와이프 가능 여부 (iOS Only)
     */
    TypeRouter["ReqRouterOpen"] = "REQ.ROUTER.OPEN";
    /**
     * Present로 열린 웹뷰를 닫아요
     * (iOS에서만 특별하게 작동해요. Android에서는 REQ.ROUTER.POP와 동일하게 작동해요.)
     */
    TypeRouter["ReqRouterClose"] = "REQ.ROUTER.CLOSE";
    /**
     * 현재 웹뷰 내 앱을 교체해요
     * @required remote       리모트 웹 주소
     * @optional navbar       상단 바 표시 여부
     * @optional navbarTitle  상단 바 내 타이틀
     * @optional scrollable   스크롤 가능 여부
     * @optional enableSafeAreaInsets Safe Area까지 꽉 채울지 여부 (iOS Only)
     * @optional backSwipable 백스와이프 가능 여부 (iOS Only)
     * 또는
     * @optional app          로컬 웹뷰 주소 (없을 경우 자기 자신)
     * @required path         로컬 웹뷰 내 경로 (HashRouter)
     * @optional navbar       상단 바 표시 여부
     * @optional navbarTitle  상단 바 내 타이틀
     * @optional scrollable   스크롤 가능 여부
     * @optional enableSafeAreaInsets Safe Area까지 꽉 채울지 여부 (iOS Only)
     * @optional backSwipable 백스와이프 가능 여부 (iOS Only)
     */
    TypeRouter["ReqRouterReplace"] = "REQ.ROUTER.REPLACE";
    /**
     * 백그라운드에서 해당 웹뷰를 미리 다운로드 받아놓아요
     * @required app  로컬 웹뷰 주소
     */
    TypeRouter["ReqRouterPrefetch"] = "REQ.ROUTER.PREFETCH";
    /**
     * 현재 웹뷰의 스타일을 변경해요
     * @optional navbar       상단 바 표시 여부
     * @optional navbarTitle  상단 바 내 타이틀
     * @optional scrollable   스크롤 가능 여부
     * @optional enableSafeAreaInsets Safe Area까지 꽉 채울지 여부 (iOS Only)
     * @optional backSwipable 백스와이프 가능 여부 (iOS Only)
     */
    TypeRouter["ReqRouterStyle"] = "REQ.ROUTER.STYLE";
})(TypeRouter = exports.TypeRouter || (exports.TypeRouter = {}));
//# sourceMappingURL=Router.js.map